import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProdutoCliente} from '../../models'

interface IProdutoClienteState{
    produtosClientes: IProdutoCliente[]
}

const initialState: IProdutoClienteState = {
    produtosClientes: []
}

const produtoClienteSlice = createSlice({
    name: 'ProdutoCliente',
    initialState,
    reducers: {
        setProdutoClienteState(state, action:PayloadAction<IProdutoCliente[]>) {
            state.produtosClientes = action.payload
        },
        resetProdutoClienteState(state, action:PayloadAction<IProdutoCliente>) {
            state.produtosClientes = initialState.produtosClientes
        }
    }
})

export const {
    setProdutoClienteState
} = produtoClienteSlice.actions

export const produtoClienteReducer = produtoClienteSlice.reducer